import { render, staticRenderFns } from "./registroDomiciliacion.vue?vue&type=template&id=2ebee356"
import script from "./registroDomiciliacion.vue?vue&type=script&lang=js"
export * from "./registroDomiciliacion.vue?vue&type=script&lang=js"
import style0 from "./registroDomiciliacion.vue?vue&type=style&index=0&id=2ebee356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports